<!-- Paletas Pre-Definidas -->
<div class="seletor-secao">
  <h5 class="seletor-secao-titulo">
    <i class="fas fa-swatchbook text-primary mr-2"></i>
    Paletas Pre-Definidas
  </h5>
  <div class="paletas-scroll">
    <div class="paletas-grid">
      <div class="paleta-card"
           *ngFor="let paleta of paletasPreDefinidas; let i = index"
           [class.paleta-selecionada]="paletaSelecionadaIndex === i"
           (click)="aplicarPaleta(i)"
           (mouseenter)="onHoverPaleta(i)"
           (mouseleave)="onHoverSair()">
        <div class="paleta-info">
          <span class="paleta-emoji">{{paleta.emoji}}</span>
          <span class="paleta-nome">{{paleta.nome}}</span>
        </div>
        <div class="paleta-swatches">
          <span class="paleta-swatch" [style.backgroundColor]="paleta.corPrimaria"></span>
          <span class="paleta-swatch" [style.backgroundColor]="paleta.corSecundaria"></span>
          <span class="paleta-swatch" [style.backgroundColor]="paleta.corFundo"></span>
          <span class="paleta-swatch" [style.backgroundColor]="paleta.corFundoCard"></span>
        </div>
      </div>
    </div>
  </div>
</div>
